export enum Type {
  Demo = 'demo',
  Trader = 'trader',
  Partner = 'partner',
}
